import { render } from "./text-underline2.vue?vue&type=template&id=9d477500&scoped=true"
const script = {}

import "./text-underline2.vue?vue&type=style&index=0&id=9d477500&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d477500"],['__file',"src/views/other/cssfx/components/text-underline2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d477500"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d477500', __exports__)) {
    console.log('reload')
    api.reload('9d477500', __exports__)
  }
  
  module.hot.accept("./text-underline2.vue?vue&type=template&id=9d477500&scoped=true", () => {
    console.log('re-render')
    api.rerender('9d477500', render)
  })

}


export default __exports__